import { RootState } from '../../rootReducer';

export const countryListSelector = (state: RootState) => state.entitiesModuleReducer.CountryReducer;
